/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_File_Tree_Toast_Success_UnmodifiedInputs */

const es_components_file_tree_toast_success_unmodified = /** @type {(inputs: Components_File_Tree_Toast_Success_UnmodifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sin cambios`)
};

const en_components_file_tree_toast_success_unmodified = /** @type {(inputs: Components_File_Tree_Toast_Success_UnmodifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} unmodified`)
};

/**
* | output |
* | --- |
* | "{count} unmodified" |
*
* @param {Components_File_Tree_Toast_Success_UnmodifiedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_toast_success_unmodified = /** @type {((inputs: Components_File_Tree_Toast_Success_UnmodifiedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Toast_Success_UnmodifiedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_toast_success_unmodified(inputs)
	return en_components_file_tree_toast_success_unmodified(inputs)
});
export { components_file_tree_toast_success_unmodified as "components.file_tree.toast_success_unmodified" }